import React from "react";

const FooterBottom = () => {
  const year = new Date().getFullYear();

  return (
    <div className="w-full py-10">
      <p className="text-center text-slate-500 text-sm font-mono">
        © {year}. All rights reserved by Tarigopula Chandra Mouli
      </p>
    </div>
  );
};

export default FooterBottom;
